import { create } from "zustand";

import type { MembershipInfo, TenantInfo, UserInfo } from "@/lib/types";

type AuthState = {
  user: UserInfo | null;
  tenant: TenantInfo | null;
  memberships: MembershipInfo[];
  loaded: boolean;
  // Cross-tenant super-admin flag (the SaaS owners). Hydrated by the Shell
  // calling /superadmin/whoami on mount; falls back to false if the call fails
  // or the user isn't a super admin.
  isSuperAdmin: boolean;
  // True once the user's employee_profile has phone + address + resume. Until
  // then, RequireAuth redirects every route except /onboard/profile and
  // /logout. Super-admins always read True (they're not consultancy employees).
  profileComplete: boolean;
  setSession: (s: {
    user: UserInfo;
    tenant: TenantInfo;
    memberships: MembershipInfo[];
    profileComplete?: boolean;
  }) => void;
  setSuperAdmin: (flag: boolean) => void;
  setProfileComplete: (flag: boolean) => void;
  clear: () => void;
  markLoaded: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  tenant: null,
  memberships: [],
  loaded: false,
  isSuperAdmin: false,
  profileComplete: true,
  setSession: ({ user, tenant, memberships, profileComplete }) =>
    set({
      user,
      tenant,
      memberships,
      loaded: true,
      profileComplete: profileComplete ?? true,
    }),
  setSuperAdmin: (flag) => set({ isSuperAdmin: flag }),
  setProfileComplete: (flag) => set({ profileComplete: flag }),
  clear: () =>
    set({
      user: null,
      tenant: null,
      memberships: [],
      loaded: true,
      isSuperAdmin: false,
      profileComplete: true,
    }),
  markLoaded: () => set({ loaded: true }),
}));
